import { render, staticRenderFns } from "./MyWellbeingCheckReminder.vue?vue&type=template&id=0e2d2261&scoped=true&"
import script from "./MyWellbeingCheckReminder.vue?vue&type=script&lang=js&"
export * from "./MyWellbeingCheckReminder.vue?vue&type=script&lang=js&"
import style0 from "./MyWellbeingCheckReminder.vue?vue&type=style&index=0&id=0e2d2261&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2d2261",
  null
  
)

export default component.exports